import VueRouter from "vue-router";
import {ApiException, ResultError} from "@/api-client";
import {authService} from "@/AuthService";
import toasts from "@/components/Toasts";
import bus from "@/EventBus";

export const tryHandleError = (error : Error | ResultError, router : VueRouter): boolean => {
    
    if (error instanceof ApiException) {
        if (error.status == 401) {
            const returnUrl = window.location.pathname + window.location.search;
            authService.startAuthentication(encodeURI(returnUrl));
            return true;
        }
        else if (error.status == 403) {
            router.push({ name: "forbidden" })
            return true;
        }
        else if (error.status == 404) {
            router.push({ name: "not-found" })
            return true;
        }
        else {
            router.push({ name: "server-error" })
            return true;
        }
    }

    if (error instanceof ResultError) {
        if (error.hasMessages('concurrency')) {
            bus.publish('concurrency-error-occurred', error.getAndSetAsHandled('concurrency').join('. '));
        }

        for (const message of error.getNotHandledMessages()) {
            toasts.failure(message, 0);
        }
        
        return true;
    }
    
    return false;
}